module.exports = __webpack_public_path__ + "static/media/mama_soul_logo.c71762ee.svg";